import React from 'react';
import { Frame } from './style';

const MeetTileFrame = ({ children }) => <Frame>{children}</Frame>;

export default MeetTileFrame;
